import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('sipekaes_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes('/auth/login')) {
      localStorage.removeItem('sipekaes_token');
      localStorage.removeItem('sipekaes_user');
      if (!window.location.pathname.includes('/login')) window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  me: () => api.get('/auth/me'),
  updateMe: (data) => api.put('/auth/me', data),
};

export const crud = (entity) => ({
  list: (params) => api.get(`/${entity}`, { params }),
  get: (id) => api.get(`/${entity}/${id}`),
  create: (data) => api.post(`/${entity}`, data),
  update: (id, data) => api.put(`/${entity}/${id}`, data),
  remove: (id) => api.delete(`/${entity}/${id}`),
});

export const partisipanApi = {
  ...crud('partisipan'),
  checkDuplicate: (data) => api.post('/partisipan/check-duplicate', data),
  deleteAll: () => api.delete('/partisipan'),
};
export const dptApi = {
  ...crud('dpt'),
  search: (q, params = {}) => api.get('/dpt/search', { params: { q, ...params } }),
  statsWilayah: () => api.get('/dpt/stats/wilayah'),
  deleteAll: () => api.delete('/dpt'),
};
export const potensiEksternalApi = crud('potensi-eksternal');
export const calegApi = {
  ...crud('caleg'),
  summary: () => api.get('/caleg/summary'),
};
export const pejabatPublikApi = {
  ...crud('pejabat-publik'),
  summary: () => api.get('/pejabat-publik/summary'),
};
export const kegiatanApi = crud('kegiatan');
export const agendaApi = crud('agenda');
export const tugasApi = crud('tugas');
export const usersApi = {
  list: () => api.get('/users'),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  remove: (id) => api.delete(`/users/${id}`),
};

export const passwordApi = {
  change: (old_password, new_password) => api.post('/auth/change-password', { old_password, new_password }),
};

export const dapilApi = {
  list: () => api.get('/dapil'),
};

export const desaApi = {
  list: () => api.get('/wilayah/desa'),
};

export const adminApi = {
  resetDemo: () => api.post('/admin/reset-demo-data'),
};

export const notificationsApi = {
  list: () => api.get('/notifications'),
};

export const organisasiApi = {
  list: (jenis) => api.get(`/organisasi/${jenis}`), // jenis: dpc|dpra|pelopor|rki
  export: (jenis) => api.get(`/organisasi/${jenis}/export/excel`, { responseType: 'blob' }),
};

export const wilayahTargetApi = {
  list: (params) => api.get('/wilayah-target', { params }),
  upsert: (data) => api.post('/wilayah-target', data),
  update: (id, data) => api.put(`/wilayah-target/${id}`, data),
  remove: (id) => api.delete(`/wilayah-target/${id}`),
  realisasi: (params) => api.get('/wilayah-target/realisasi', { params }),
  history: (params) => api.get('/wilayah-target/history', { params }),
  templateExcel: () => api.get('/wilayah-target/template/excel', { responseType: 'blob' }),
  importExcel: (formData) => api.post('/wilayah-target/import/excel', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
};

export const settingsApi = {
  getBaselineCutoff: () => api.get('/settings/baseline-cutoff'),
  setBaselineCutoff: (cutoff_date) => api.put('/settings/baseline-cutoff', { cutoff_date }),
};

export const quickCountApi = {
  list: () => api.get('/quick-count'),
  create: (data) => api.post('/quick-count', data),
  update: (id, data) => api.put(`/quick-count/${id}`, data),
  remove: (id) => api.delete(`/quick-count/${id}`),
  summary: () => api.get('/quick-count/summary'),
};

export const statsApi = {
  summary: () => api.get('/stats/summary'),
  perKecamatan: () => api.get('/stats/per-kecamatan'),
  kecamatanDetail: () => api.get('/stats/kecamatan-detail'),
  desaDetail: () => api.get('/stats/desa-detail'),
  rwDetail: () => api.get('/stats/rw-detail'),
  potensiEksternalDetail: () => api.get('/stats/potensi-eksternal-detail'),
  dailyGrowth: (days = 30) => api.get('/stats/daily-growth', { params: { days } }),
};

export const partisipanExcelApi = {
  downloadTemplate: () => api.get('/partisipan/template/excel', { responseType: 'blob' }),
  export: () => api.get('/partisipan/export/excel', { responseType: 'blob' }),
  import: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/partisipan/import/excel', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const dptExcelApi = {
  downloadTemplate: () => api.get('/dpt/template/excel', { responseType: 'blob' }),
  export: () => api.get('/dpt/export/excel', { responseType: 'blob' }),
  import: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/dpt/import/excel', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export default api;
